import React from 'react';
import Header from 'components/header/Header';
import Footer from 'components/footer/footer';
import TrainingContactForm from 'pages/training/mattsTraining/trainingContacts/TrainingContactForm';

const MattsTraining = () => {
  return (
    <>
      <Header />
      <TrainingContactForm />
      <Footer />
    </>
  );
};

export default MattsTraining;
